import { initialHeaderState, modalFadeIn, setOpen } from '@/stores'
import { useDispatch } from 'react-redux'

export const SummaryLogin: React.FC = () => {
  const dispatch = useDispatch()

  const handleClickLogin = (e) => {
    e.stopPropagation()
    dispatch(
      setOpen({
        ...initialHeaderState.open,
        modalBackdrop: true,
        modalLoginForm: modalFadeIn,
      })
    )
  }
  return (
    <div className="flex justify-center">
      <a
        className="text-[15px] sm:text-[17px] text-[#2dacdb] dark:text-[#337ab7] hover:underline cursor-pointer"
        data-toggle="modal"
        data-target="#login-form"
        onClick={handleClickLogin}
      >
        ログイン（会員登録済み、法人利用の方）
      </a>
    </div>
  )
}
